import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import InfoIcon from "../../../assets/icn/info.png";
import { ModalProvider } from "../../../contexts/StockPageModal";
import Image from "next/image";

import Actions from "@/elements/Actions";
import { capitalized, putComma } from "@/lib/utils";

const modalData = [
    {
        heading: "PE ratio",
        details: `PE ratio shows what the market is willing to pay today for a stock based on its future earnings`
    },
    {
        heading: `PB ratio`,
        details: `PB ratio measures the market's valuation of a company relative to the current value of the assets on its books, if they were to be sold
        immediately`
    },
    {
        heading: `Dividend yield`,
        details: `Dividend yield tells you the percentage of a company's share price that it pays out in dividends each year`
    },
    {
        heading: `Market cap`,
        details: `Market Cap is the total market value of all of a company's outstanding shares`
    },
    {
        heading: `RSI`,
        details: `RSI is a measurement used to assess the price momentum of a stock .`
    },
    {
        heading: `50 DMA`,
        details: `50 DMA shows you the average closing price of a stock over the previous 50 days`
    },
    {
        heading: `200 DMA`,
        details: `200 DMA shows you the average closing price of a stock over the previous 200 days`
    },
    {
        heading: `Volume`,
        details: `Volume tells you the total number of shares traded yesterday`
    }
];

function KeyIndicatorCard({ data, symbol, isPaidUserPage }) {
    const modal = useContext(ModalProvider);

    const openModalHandler = () => {
        modal.setTitle("Key indicators");
        modal.setModalData(modalData);
        modal.setModal(true);
    };

    return (
        <>
            <div className="relative mb-8 md:hidden " id="key_indicators" data-aos="xxxx-xx">
                {/* <img src={key} alt="news" className='w-[80px] h-[54px] absolute top-0 right-0 -z-10 mx-4' /> */}
                <div className="font-Inter text-sm lg:text-base text-black flex flex-row mx-4 mt-6 mb-4 font-semibold md:mt-10">
                    <h2 className="mr-4 line-clamp-1">Key indicators for {symbol} Share</h2>
                    <button className="w-4 h-4 self-center" onClick={openModalHandler}>
                        <Image src={InfoIcon} alt="info" className="w-4 min-w-4 h-4 self-center" />
                    </button>
                </div>
                <div className="rounded-xl border border-[#E5E5E5] mx-4 py-4 ">
                    <div className="mx-3 font-semibold text-[#232A31] text-xs lg:text-sm leading-[18px] font-Inter">
                        Fundamentals
                    </div>
                    <div className="mx-3font-Inter font-medium text-xs lg:text-sm flex flex-row">
                        <div className="w-1/2 mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797]  text-xs lg:text-sm">P/E</div>
                                <div className="text-[12px] ">{data.peRatio}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">P/B</div>
                                <div className="text-[12px]">{data.pbRatio}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Div Yield</div>
                                <div className="text-[12px]">{data.divYield}%</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Face Value</div>
                                <div className="text-[12px]">{data.faceValue}</div>
                            </div>
                        </div>
                        <div className="w-1/2 mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Sector P/E</div>
                                <div className="text-[12px]">{data.sectorPE}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Mkt cap</div>
                                <div className="text-[12px] font-Inter">
                                    {Actions?.trimNumber(data.marketCapital)} Cr
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">EPS</div>
                                <div className="text-[12px] font-Inter">{data.eps}</div>
                            </div>
                        </div>
                    </div>
                    <div className="h-[0.5px] self-stretch bg-[#EDEDED] mx-3 mb-3"></div>
                    <div className="mx-3 font-semibold text-[#232A31] text-xs lg:text-sm leading-[18px] font-Inter">
                        Technicals
                    </div>
                    <div className="font-Inter font-medium text-xs lg:text-sm flex flex-row">
                        <div className="w-1/2 mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">14D - RSI</div>
                                <div className="text-[12px]">
                                    {data.fourteenDaysRSI !== "NaN" && data.fourteenDaysRSI?.toFixed(2)}
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">50 DMA</div>
                                <div className="text-[12px] font-Inter">₹{putComma(data?.fiftyDMA)}</div>
                            </div>
                        </div>
                        <div className="w-1/2 mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Volume*</div>
                                <div className="text-[12px] font-Inter">
                                    {data.volume > 99999 ? `${(data.volume / 100000).toFixed(2)} L` : data.volume}
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">200 DMA</div>
                                <div className="text-[12px] font-Inter">₹{putComma(data.twoHundredDMA)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* For Big Screen */}
            <div
                className="relative  mt-6 md:mt-10 mb-8  hidden lg:flex flex-col  "
                id="key_indicators"
                data-aos="xxxx-xx"
            >
                {/* <img src={key} alt="news" className='w-[80px] h-[54px] absolute top-0 right-0 -z-10 mx-4' /> */}
                <div className="font-Inter text-[16px] text-black flex flex-row mx-4 mb-4 font-semibold">
                    <h2 className="mr-4">Key indicators {!isPaidUserPage && `for ${symbol} Share`}</h2>
                    <button className="w-[16px] h-[16px] self-center" onClick={openModalHandler}>
                        <Image src={InfoIcon} alt="info" className="w-[16px] h-[16px] self-center" />
                    </button>
                </div>
                <div className="rounded-xl border border-[#E5E5E5] mx-4 py-4 ">
                    <div className="flex flex-row justify-between">
                        <div className="mx-3 font-semibold text-[#232A31] text-xs lg:text-sm leading-[18px] font-Inter w-2/3">
                            Fundamentals
                        </div>
                        <div className="mx-3 lg:mx-0 font-semibold text-[#232A31] text-xs lg:text-sm leading-[18px] font-Inter w-1/3">
                            Technicals
                        </div>
                    </div>
                    <div className="font-Inter font-medium text-xs lg:text-sm flex flex-row justify-between">
                        <div className=" w-full mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797]  text-xs lg:text-sm">P/E</div>
                                <div className="text-[12px] ">{data.peRatio}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">P/B</div>
                                <div className="text-[12px]">{data.pbRatio}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Div Yield</div>
                                <div className="text-[12px]">{data.divYield}%</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>

                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Face Value</div>
                                <div className="text-[12px]">{data.faceValue}</div>
                            </div>
                        </div>
                        <div className="w-px h-[180px] bg-[#EDEDED]"></div>
                        <div className="w-full mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Sector P/E</div>
                                <div className="text-[12px]">{data.sectorPE}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Mkt cap</div>
                                <div className="text-[12px] font-Inter">
                                    {Actions?.trimNumber(data.marketCapital)} Cr
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">EPS</div>
                                <div className="text-[12px] font-Inter">{data.eps}</div>
                            </div>
                        </div>
                        <div className="w-px h-[180px] bg-[#EDEDED]"></div>
                        <div className="w-full mx-3 my-1">
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">14D - RSI</div>
                                <div className="text-[12px]">
                                    {data.fourteenDaysRSI !== "NaN" && data.fourteenDaysRSI?.toFixed(2)}
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">Volume*</div>
                                <div className="text-[12px] font-Inter">
                                    {data.volume > 99999 ? `${(data.volume / 100000).toFixed(2)} L` : data.volume}
                                </div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">50 DMA</div>
                                <div className="text-[12px] font-Inter">₹{putComma(data?.fiftyDMA)}</div>
                            </div>
                            <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                            <div className="flex flex-row justify-between my-[12px]">
                                <div className="text-[#979797] text-xs lg:text-sm">200 DMA</div>
                                <div className="text-[12px] font-Inter">₹{putComma(data.twoHundredDMA)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default React.memo(KeyIndicatorCard);
